module.exports = __webpack_public_path__ + "static/media/rounded-clock-grey.0a0b4782.svg";